<template>
<div class="animated fadeIn mt-5">
  <form enctype="multipart/form-data" v-on:submit="validateBeforeSubmit($event,false)">
    <div class="row">
      <b-col md="6">
        <b-card>
          <div slot="header">
            <strong>Item</strong>
          </div>
          <b-form-fieldset label="Nome">
            <b-form-input type="text" name="name" v-model="item.name" placeholder="Nome"  v-validate="'required'" :state="validateState('name')"></b-form-input>
            <b-form-invalid-feedback>
              {{ errors.first('name') }}
            </b-form-invalid-feedback>
          </b-form-fieldset>
          <b-form-fieldset label="Código">
            <b-form-input type="text" name="code" v-model="item.code" placeholder="Código"  v-validate="'required'" :state="validateState('code')"></b-form-input>
            <b-form-invalid-feedback>
              {{ errors.first('code') }}
            </b-form-invalid-feedback>
          </b-form-fieldset>

          <div slot="footer">
            <div class="row">
              <div class="col-sm-3">
                <router-link :to="{name:'top10.index'}" size="sm" variant="danger"><i class="fa fa-ban"></i> Cancelar</router-link>

              </div>
              <div class="col-sm-9 text-right">
                <b-button type="submit" size="sm" variant="primary"><i class="fa fa-save"></i> Gravar</b-button>
                <b-button type="button" v-on:click="validateBeforeSubmit($event,true)" size="sm" variant="primary"><i class="fa fa-save"></i> Gravar e fechar</b-button>
              </div>
            </div>
          </div>
        </b-card>
      </b-col>
    </div>
  </form>

</div>
</template>

<script>
import Prodaggregs from '../prodaggregs/modal.vue'
export default {
  name: 'ProductsEdit',
  props: ['id'],
  components: { Prodaggregs },
  data() {
    return {
      item: {
        name: '',
        code: ''
      }
    }
  },
  methods: {
    validateBeforeSubmit(evt, close) {
      evt.preventDefault()
      console.log('check validation')
      this.$validator.validateAll().then((result) => {
        console.log('validation results:', result)
        if (result) {
          console.log('all fields ok. submit')
          this.submit(evt, close)
          return
        }
        this.$bvToast.toast(`Tem campos inválidos`, { autoHideDelay: 5000, variant: 'danger', solid: true })
      })
    },
    validateState(ref) {
      if (this.veeFields[ref] && (this.veeFields[ref].dirty || this.veeFields[ref].validated)) {
        return !this.errors.has(ref)
      }
      return null
    },
    submit(e, close) {
      e.preventDefault()
      var data = {
        data: this.item
      }
      if (this.item.id) {
        this.axios.put('top10' + '/' + this.item.id, data)
          .then(response => {
            this.item = response.data.data
            this.$bvToast.toast(`item gravado com sucesso`, { autoHideDelay: 5000, variant: 'success', solid: true })
            if (close) {
              this.$router.push({
                name: 'top10.index'
              })
            }
          })
          .catch(response => {
            this.$bvToast.toast(`Não foi possivel gravar`, { autoHideDelay: 5000, variant: 'danger', solid: true })
          })
      } else {
        this.axios.post('top10', data)
          .then(response => {
            this.item = response.data.data
            this.$bvToast.toast(`item gravado com sucesso`, { autoHideDelay: 5000, variant: 'success', solid: true })
            this.$router.push({
              name: 'top10.edit',
              params: {
                id: this.item.id
              }
            })
          })
          .catch(response => {
            this.$bvToast.toast(`Não foi possivel gravar`, { autoHideDelay: 5000, variant: 'danger', solid: true })
          })
      }
    }
  },
  created() {
    var id = this.$route.params.id
    if (typeof id !== 'undefined') {
      this.axios.get('top10' + '/' + id)
        .then(response => {
          this.item = response.data.data
        })
        .catch(response => {
          this.$bvToast.toast(`Este item não existe`, { autoHideDelay: 5000, variant: 'danger', solid: true })
          this.$router.push({
            name: 'top10.index'
          })
        })
    }
  }
}
</script>
